<template>
  <div>
    <appeals-table
      :items="items"
      :total="total"
      :is-fetch="isFetch"
      @update:options="onTableOptionsUpdate"
    />
  </div>
</template>

<script>
  import AppealsTable from "../../components/appeals/AppealsTable.vue";
  import { list } from "@/api/appeals";
  import { mapGetters } from 'vuex';

  export default {
    name: "AppealsListPage",
    components: { AppealsTable },
    mounted() {
      this.checkAppealConnection();
    },
    watch: {
      IS_FETCHING(newVal) {
        if (!newVal) {
          this.checkAppealConnection();
        }
      },
      organizationId(newVal) {
        if (newVal) {
          this.offset = 0;
          this.fetchAppeals();
        }
      }
    },
    data(){
      return {
        items: [],
        total: 0,
        isFetch: false,
        limit: 10,
        offset: 0
      }
    },
    computed: {
      ...mapGetters('organization', ['ID_ORG', 'appealsServiceConnection', 'IS_FETCHING']),
      organizationId() {
        return this.ID_ORG;
      }
    },
    methods: {
      checkAppealConnection() {
        if (this.IS_FETCHING) {
          return;
        }
        if (this.appealsServiceConnection.status !== 'CONNECTED') {
          this.$router.push({ name: 'appeals.connect'});
          return;
        }
        this.fetchAppeals();
      },
      async fetchAppeals() {
        this.isFetch = true;
        try {
          const response = await list(this.organizationId, this.limit, this.offset);
          this.items = response.data.data || [];
          this.total = response.data.total || 0;
        } catch (error) {
          const errorText = error && error.response && error.response.data && error.response.data.error;
          if(errorText){
            this.$store.dispatch('notifications/SHOW_ERROR', errorText);
          }else{
            this.$store.dispatch('notifications/SHOW_ERROR', 'Ошибка при загрузке данных');
          }
          console.error('Ошибка при загрузке данных:', error);
        } finally {
          this.isFetch = false;
        }
      },
      onTableOptionsUpdate(options) {
        this.limit = options.limit;
        this.offset = options.offset;
        this.fetchAppeals();
      }
    }
  }
</script>

<style scoped>

</style>